import { render, staticRenderFns } from "./DocumentSignature.vue?vue&type=template&id=3ba7d5f7&scoped=true"
import script from "./DocumentSignature.vue?vue&type=script&lang=ts"
export * from "./DocumentSignature.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSignature.vue?vue&type=style&index=0&id=3ba7d5f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7d5f7",
  null
  
)

export default component.exports